export async function trackPaidCtaClicked(trackFunnelEvent, {
  userId,
  currentPlan = 'free',
  targetPlan = 'paid',
  surface = 'billing',
} = {}) {
  if (typeof trackFunnelEvent !== 'function') {
    return;
  }

  await trackFunnelEvent('paid.cta.clicked', {
    userId,
    metadata: {
      current_plan: currentPlan,
      target_plan: targetPlan,
      surface,
    },
  });
}

export async function trackPaymentCompleted(trackFunnelEvent, {
  userId,
  subscription,
  surface = 'subscription_checkout',
} = {}) {
  if (typeof trackFunnelEvent !== 'function' || !subscription) {
    return;
  }

  await trackFunnelEvent('payment.completed', {
    userId,
    metadata: {
      plan_id: subscription.planId || 'unknown',
      status: subscription.status || 'unknown',
      subscription_id: subscription.id || 'unknown',
      surface,
    },
  });
}
